import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../store/User';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { getFeatureByRoute } from '../features/featureMapping';
import { useFeatures } from './useFeatures';

export const useFeatureTracking = () => {
  const location = useLocation();
  const { data: user } = useUser();
  const launchDarkly = useLaunchDarkly();
  const { addFeature } = useFeatures();

  useEffect(() => {
    // Only track features when NEW badge feature is enabled
    const isNewBadgeFeatureEnabled = launchDarkly?.['new-badge-feature-enabled'] ?? false;
    if (!isNewBadgeFeatureEnabled || !user) return;

    const currentPath = location.pathname;
    const feature = getFeatureByRoute(currentPath);

    if (!feature) return;

    const userFeatures = user.features || [];

    const hasVisited = userFeatures.includes(feature.name);

    if (!hasVisited) {
      addFeature(feature.name);
    }
  }, [location.pathname, user, launchDarkly, addFeature]);
};
